<template>
  <div class="public-intro-content" id="plataforma-de-marca-publico-intro" data-search-anchor>
    <div class="description-public-intro-content">
      <h1 class="public-intro-description">{{ introDescription }}</h1>
    </div>

    <div class="public-intro-card-item" :style="{ backgroundImage: `url(${introImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import  PublicPageMixin from '@/mixins/public-page-mixin'
import { PublicPageStore } from '@/store/brand-plataform-page/public-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
 
@Component({})
export default class PublicIntroSection extends Mixins(PublicPageMixin) {
  publicPageStore: PageStoreContract = getModule(PublicPageStore, this.$store)

  get introDescription(): string {
    return this.getElementText(1, 0)
  }

  get introImageSrc(): string {
    return this.getElementMedia(1, 1)
  }

  async getPublicPage(): Promise<void> {
    await this.publicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.publicPageStore.isLoading) {
      await this.getPublicPage()
    }
  }
}
</script>

<style lang="scss">
.public-intro-content {
  display: grid;
  grid-template-columns: 47% 53%;
  max-width: 1032px;
  width: 100%;
}

.description-public-intro-content {
  margin-top: 1rem;
  padding-right: 38px;
}

.public-intro-description {
  font-size: 56px;
  font-weight: 400;
  line-height: 60px;
  white-space:pre-line;
  text-align: left;
  margin: 0;
}

.public-intro-card-item {
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
